import { isNative } from './platform';

export interface InstalledApp {
  versionCode: number;
  versionName: string;
}

/** The APK this WebView runs in, or null on the web. */
export async function installedApp(): Promise<InstalledApp | null> {
  if (!isNative) return null;
  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    return { versionCode: Number(info.build), versionName: info.version };
  } catch {
    return null;
  }
}
